import './DateRangeSelector.css';
export var selector = '_1uftu980-3-15-1';